import type { DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import Driver from '/@/components/driverjs';
import { _ } from '/@/locale';
import { GROWERS_HELP_TOUR_STORAGE_KEY } from '../growers-help-tour-ids';

type GrowersHelpTourDriverProps = {
    steps: DriveStep[];
    isLoading: boolean;
    onBeforeAutoStart?: () => void;
};

/** Auto-started onboarding driver for Mis Productores (same steps as manual help tour). */
const GrowersHelpTourDriver = ({ steps, isLoading, onBeforeAutoStart }: GrowersHelpTourDriverProps) => {
    return (
        <Driver
            ONBOARDING_STORAGE_KEY={GROWERS_HELP_TOUR_STORAGE_KEY}
            DRIVER_STEPS={steps}
            isLoading={isLoading}
            popoverTag={_('MIS PRODUCTORES')}
            onBeforeAutoStart={onBeforeAutoStart}
            mixpanelSection='growers'
            showHelpCenterLink
        />
    );
};

export default GrowersHelpTourDriver;
